import React from 'react';
import WMS from '../../LandingPage/index'

const App = () => {
  return (
    <div>
      <WMS />
    </div>
  )
}

export default App;
